import { ethers } from 'ethers';
import emdmAbiJson from '../abis/emdm.abi.json';

const useMetamask = ({ erc20ContractAddress }) => {
  if (typeof window.ethereum === `undefined`) {
    return {};
  }
  if (!erc20ContractAddress) {
    return {};
  }

  const provider = new ethers.providers.Web3Provider(window.ethereum);

  const signer = provider.getSigner(erc20ContractAddress);

  const contract = new ethers.Contract(
    erc20ContractAddress,
    emdmAbiJson,
    provider,
  );

  return {
    provider,
    signer,
    contract,
  };
};

export default useMetamask;
